<template>
    <div>
     <!-- 面包屑导航 -->
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>年费管理（显示年费库中所有数据）</el-breadcrumb-item>
     </el-breadcrumb>
     <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" @click="refresh" title="点击刷新页面">刷新</el-button>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search" title="点击跳转国知局查询专利年费">年费查询</el-button>
        <el-button size="small" type="warning">账号1:17628291613</el-button>
        <el-button size="small" type="warning">密码1:Ty@12345678</el-button>
      </el-form-item>
     <el-form-item>
        <el-input size="small" v-model="formInline.zlid" style="width:120px" placeholder="输入专利号"></el-input>
      </el-form-item>
     <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择开始时间"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择结束时间"> </el-date-picker>
      </el-form-item>
     <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="searchData">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" >
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column align="center" prop="zlid" label="专利号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zlid_code" label="专利号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="jfzt" label="专利状态" :formatter="jfztFormat" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="category" label="费用种类" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="money" label="应缴金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="date_time" label="截止日期" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="update_time" label="更新时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="warning" @click="updPatDate(scope.$index, scope.row)" title="年费数据一致,直接更新时间">更新</el-button>
          <el-button size="mini" type="warning" @click="handleInput(scope.$index, scope.row)" title="年费录入">录入</el-button>
          <el-button size="mini" type="danger" @click="delMonitor(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 监控详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="专利号">
              <el-input size="small" v-model="infoForm.zlid" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专利号">
              <el-input size="small" v-model="infoForm.zlid_code" auto-complete="off" disabled></el-input>
            </el-form-item>     
          </el-col>

            <el-form-item label="专利状态" prop="status">
                <el-radio v-model="infoForm.status" :label="4">失效</el-radio>
                <el-radio v-model="infoForm.status" :label="5">缴完</el-radio>
            </el-form-item>

            <el-form-item label="说明">
                <span style="color: red">如果该专利已失效或年费已缴完。请修改专利状态，如不属于请勿修改！</span>
            </el-form-item>

            <el-form-item>
              <el-button size="mini" type="primary" @click="submitStatusForm('infoForm')">保存</el-button>
              <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
            </el-form-item>

               
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 年费录入界面 -->
    <el-dialog :title="title" :visible.sync="feeFormVisible" width="50%" @click="closeDialog('feeForm')">
    <el-form :model="annualFeeForm" ref="annualFeeForm" label-width="100px" class="demo-dynamic">
            
        <el-row>
          <el-col :span="12">
            <el-form-item label="专利号">
              <el-input size="small" v-model="feeForm.zlid" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专利号">
              <el-input size="small" v-model="feeForm.zlid_code" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      <el-form-item label="待缴年费">
        <el-row class="demo-autocomplete">
              <el-col :span="6">
                <div class="sub-title" style="color: #909399">费用种类</div>
              </el-col>
              <el-col :span="6">
                <div class="sub-title" style="color: #909399">应缴金额</div>
              </el-col>
              <el-col :span="6">
              <div class="sub-title" style="color: #909399">缴费截止日</div>
            </el-col>
          </el-row>
      </el-form-item>

       <el-form-item
        v-for="(domain, index) in annualFeeForm.pay_able"
        :label="'费用' + index"
        :key="domain.key"
      >
      <el-row class="demo-autocomplete">
            <el-col :span="6">
              <el-input :prop="domain.category" v-model="domain.category" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:发明专利第6年年费"></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 15px">
            <el-input :prop="domain.money" v-model="domain.money" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:1200"></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 15px">
              <el-input :prop="domain.date" v-model="domain.date" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:2021-05-06"></el-input>
            </el-col>
            <el-button @click.prevent="removeDomain(domain)" style="margin-left: 15px">删除</el-button>
            <el-button @click.prevent="addOnNodeDomain(domain)" title="当前节点上方添加录入框">添加(上)</el-button>
            <el-button @click.prevent="addNextNodeDomain(domain)" title="当前节点下方添加录入框">添加(下)</el-button>
      </el-row>
        <!-- <el-input v-model="domain.value"></el-input> -->
        
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('annualFeeForm')">提交</el-button>
        <el-button @click="addDomain">新增录入行</el-button>
        <!-- <el-button @click="resetForm('annualFeeForm')">重置</el-button> -->
      </el-form-item>
    </el-form>

    </el-dialog>

    </div>
</template>

<script>
import { webPatFeeList, webPatFeeUpdDate, webPatUpdOneFee, webUpdPatStatus } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      feeFormVisible: false, //控制年费录入页面显示与隐藏
      title: '监控详情',
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      infoForm: {
        zllx: '',
        zlmc: '',
        zlid: '',
        zlid_code: '',
        apply_date: ''
      },
      formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        zlid: ''
      },
      feeForm: {
        zlid: '',
        zlmc: ''
      },
      listData: [], //用户数据
      feeData: [], // 年费数据
      annualFeeForm: {
          zlid: '',
          pay_able: [{
            category: '',
            money: '',
            date: ''
          }],
        },
     // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
        this.loading = true
        if(parameter.start_time == null){
            parameter.start_time = ''
        }
        if(parameter.end_time == null){
            parameter.end_time = ''
        }
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webPatFeeList(parameter)
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 刷新页面
    refresh() {
        this.getdata(this.formInline)
    },
    // 搜索事件
    searchData() {
      this.getdata(this.formInline)
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    //根据不同值显示不同文本内容
    jfztFormat(row,column){
      if(row.jfzt == 1){
          return '维持'
      }else if(row.jfzt == 2){
          return '紧急'
      }else if(row.jfzt == 3){
          return '滞纳'
      }else if(row.jfzt == 4){
          return '失效'
      }else if(row.jfzt == 5){
          return '缴完'
      }else{
          return '未知'
      }
    },
    // 搜索事件
    search() {
      window.open("http://cpquery.cnipa.gov.cn/", "_blank");
    },
    //显示详情界面
    handleInfo: function(index, row) {
      // console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    //显示年费录入界面
    handleInput: function(index,row){
        if(row.jfzt == 4 || row.jfzt == 5){
            this.$message({
                type: 'info',
                message: '该状态不支持录入!'
            })
            return false
        }
        this.title = '年费录入'
        this.feeFormVisible = true
        this.feeForm = row
        this.annualFeeForm.zlid = row.zlid
        this.annualFeeForm.pay_able = row.pay_able
    },
    //更新年费时间
    updPatDate: function(index,row){
      const updParam = {
            zlid:row.zlid
        }
    this.$confirm('确定更新?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          webPatFeeUpdDate(updParam)
            .then(res => {
              console.log(res)
              res = checkLogin(res)
              if (res.code == 200) {
                this.loading = false
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              location.reload()
              
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消更新'
          })
        })
    },  
    // 删除监控记录
    delMonitor(index, row) {
        this.$message({
          type: 'info',
          message: '暂不支持!'
        })
        return false;
    },
    // 提醒勾选中的记录
    remindCheck(index, row) {
        this.$message({
          type: 'info',
          message: '暂不支持!'
        })
        return false;
    },

    submitForm(formName) {
    this.$refs[formName].validate((valid) => {
      console.log(valid)
      if (valid) {
      const param = { zlid:this.annualFeeForm.zlid,pay_able:JSON.stringify(this.annualFeeForm.pay_able) }
      webPatUpdOneFee(param)
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            location.reload()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  },
  submitStatusForm(formName){
    if(!this.infoForm.status){
        this.$message({
            type: 'error',
            message: '未勾选状态无法保存，请慎重！'
          })
          return false
    }
    const editParam = {zlid:this.infoForm.zlid, jfzt:this.infoForm.status}
        webUpdPatStatus(editParam)
            .then(res => {
              console.log(res)
              res = checkLogin(res)
              if (res.code == 200) {
                this.editFormVisible = false
                this.loading = false
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              this.getdata(this.formInline)
              
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
  },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      if (index !== -1) {
        this.annualFeeForm.pay_able.splice(index, 1)
      }
    },
    // 当前节点添加输入行
    addOnNodeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      this.annualFeeForm.pay_able.splice(index, 0,{key: Date.now()})
    },
    addNextNodeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      this.annualFeeForm.pay_able.splice(index+1, 0,{key: Date.now()})
    },
    addDomain() {
      this.annualFeeForm.pay_able.push({
        key: Date.now()
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
    
  }
}
   
</script>


// WEBPACK FOOTER //
// src/views/patent/Feemanage.vue